import { types } from "../types/types";

const initialState = {
  searchResult: {}
};
export const searchResultReducer = (state = initialState, action) => {
  switch (action.type) {

    case types.SEARCH_RESULT_START_REGISTER:
      return {
        ...state,
        searchResult: action.payload
      };

    case types.SEARCH_INFO_CLEAN_SEARCH_TEXT:
      return {
        ...state,
        searchTextInStore: "",
      };

    case types.SEARCH_INFO_SET_SEARCH_TEXT:
      return {
        ...state,
        searchTextInStore: action.payload,
      };

    default:
      return state;
  }
};